import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_TIERS = `${API_URL}/adminWeb/subscription-tiers`
const DELETE_TIER = `${API_URL}/adminWeb/subscription-tier/`
const ADD_TIER = `${API_URL}/adminWeb/subscription-tier`
const UPDATE_TIER = `${API_URL}/adminWeb/subscription-tier/`
export const getSubscriptionTiers = createAsyncThunk(
  "getSubscriptionTiers",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_TIERS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateSubscriptionTier = createAsyncThunk(
  "updateSubscriptionTier",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${UPDATE_TIER}${values.id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getSubscriptionTiers({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addSubscriptionTier = createAsyncThunk(
  "addSubscriptionTier",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${ADD_TIER}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getSubscriptionTiers({ page: values.selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSubscriptionTier = createAsyncThunk(
  "deleteSubscriptionTier",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${DELETE_TIER}${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getSubscriptionTiers({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
